export function sizeToState(profile) {
  return {
    braSize: (profile.profile && profile.profile['bra-size']) || '',
    braletteSize: (profile.profile && profile.profile['bralette-size']) || '',
    undieSize: (profile.profile && profile.profile['bottom-size']) || '',
    lingerieSleepSize:
      (profile.profile && profile.profile['lingerie-sleep-size']) || '',
  };
}
